<template>
  <div class="local-estableshiment-filter">
    <template v-if="isAdmin || isAnunciante">    
      <local-filter v-if="hasEstableshimentFilter"
                    :data-entity="entity" />
    </template>
    <local-filter v-if="isEstabelecimento && !isAdmin"
                  :data-entity="entity" />
  </div>
</template>

<script>
import dataEntityProp from "@mixins/data-entity-prop";
import LocalFilter from "@components/filters/LocalFilter";

export default {
  components: {
    LocalFilter,
  },

  mixins: [dataEntityProp],

  data() {
    return {};
  },

  computed: {
    isAnunciante() {
      return (
        this.$store.state.users.user &&
        this.$store.state.users.user.tipo === "ANUNCIANTE"
      );
    },
    isEstabelecimento() {
      return (
        this.$store.state.users.user &&
        this.$store.state.users.user.tipo === "ESTABELECIMENTO"
      );
    },
    hasEstableshimentFilter() {
      return !!this.$store.state[this.entity].filters.establishments.length;
    },
    isAdmin() {
      return this.$store.state.users.admin && !this.$store.state.users.user;
    },
  },
};
</script>

<style lang="scss" scoped>
.local-estableshiment-filter {
  display: flex;
  gap: 40px;
}
</style>
